module.exports = __webpack_public_path__ + "img/Steve Clouse.f63ff333.jpg";